<template>
    <div>
      <h3>Feedback:</h3>
      <div class="row">
        <div class="col-md-2 mb-4 text-center" v-if="editar && permiso('BAB1EE7F')">
          <b-button variant="secondary" @click="nuevo">Agregar</b-button>
        </div>
        <div :class="{ 'col-md-8': editar && permiso('BAB1EE7F'), 'col-md-12': !editar || !permiso('BAB1EE7F') }" > 
          <b-table-simple hover small caption-top responsive>
            <b-thead head-variant="light"> <!---->
              <!-- b-th>#</b-th -->
              <b-th>Rango</b-th>
              <b-th>Titulo</b-th>
              <b-th>Acción</b-th>
            </b-thead>
            <b-tbody v-if="lista && lista.length">
              <b-tr  v-for="tema in lista" :key="tema.id">
                <!--b-td>{{index}}</b-td-->
                <b-td>{{tema.rango}}</b-td>
                <b-td>{{tema.archivo_nombre}}</b-td>
                <b-td>
                  <b-button variant="outline-light" size="sm" @click="view(tema)">
                    <b-icon icon="file-text-fill" variant="info"></b-icon>
                   </b-button>
                   <b-button v-if="editar && permiso('BAB1EE7F')" variant="outline-light" size="sm" @click="edit(tema)">
                    <b-icon icon="pencil-square" variant="warning"></b-icon>
                   </b-button>
                   <b-button v-if="editar && permiso('BAB1EE7F')" variant="outline-light" size="sm" @click="remove(tema)">
                    <b-icon icon="clipboard-x" variant="danger"></b-icon>
                   </b-button>
                </b-td>
              </b-tr>
            </b-tbody>
            <tbody v-else>
              
              <tr>
                <td colspan="4" class="text-center">
                  No se encontaron resultados
                </td>
              </tr>
            </tbody>

          </b-table-simple>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-modal  no-close-on-backdrop no-close-on-esc title="Nuevo" ok-only v-model="show_nuevo"  id="modalNuevo" 
          hide-footer
          header-bg-variant="info" header-text-variant="white"><!-- @ok="" -->
            <template #modal-title>
              <h1 v-if="tema" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ tema.nombre }} - Feedback Nuevo </h1>
              <h1 v-else class="text-center navbar-brand pt-0 pb-0 mb-0">Feedback Nuevo </h1>
            </template>
            <FeedbackNuevo :tema_id="tema_id" @cerrar="show_nuevo = false" @actualizar="actualizar"></FeedbackNuevo>
    
          </b-modal>
          <b-modal  no-close-on-backdrop no-close-on-esc title="Detalle" ok-only v-model="show_detalle"  id="modalDetalle" 
          hide-footer
          header-bg-variant="info" header-text-variant="white"><!-- @ok="" -->
            <template #modal-title>
              <h1 v-if="tema" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ tema.nombre }} - Feedback Detalle </h1>
              <h1 v-else class="text-center navbar-brand pt-0 pb-0 mb-0">Feedback Detalle </h1>
            </template>
            <FeedbackDetalle :logro="logro" @cerrar="show_detalle = false"></FeedbackDetalle>
    
          </b-modal>
          
          <b-modal  no-close-on-backdrop no-close-on-esc title="Editar" ok-only v-model="show_editar"  id="modalEditar" 
          hide-footer
          header-bg-variant="info" header-text-variant="white"><!-- @ok="" -->
            <template #modal-title>
              <h1 v-if="tema" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ tema.nombre }} - Feedback Editar </h1>
              <h1 v-else class="text-center navbar-brand pt-0 pb-0 mb-0">Feedback Editar </h1>
            </template>
            <FeedbackEditar :logro="logro" @cerrar="show_editar = false" @actualizar="actualizar"></FeedbackEditar>
    
          </b-modal>
    
          <b-modal  no-close-on-backdrop no-close-on-esc title="Eliminar" v-model="show_eliminar"  id="modalEliminar" 
          header-bg-variant="info" header-text-variant="white"><!-- @ok="" -->
            <template #modal-title>
              <h1 v-if="tema" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ tema.nombre }} - Feedback Eliminar </h1>
              <h1 v-else class="text-center navbar-brand pt-0 pb-0 mb-0">Feedback Editar </h1>
            </template>
            <b-row>
              <b-col cols="12">
                <p v-if="logro">{{logro.titulo}}</p>
              </b-col>
            </b-row>
    
            <template #modal-footer="{ ok, cancel }">
              <b-button v-if="false" size="sm" variant="outline-danger" @click="ok()">
                Ok
              </b-button>
    
              <b-button size="sm" variant="outline-secondary" @click="show_eliminar = false">
                Cancelar
              </b-button>
              <!-- Button with custom close trigger value -->
              <b-button size="sm" variant="danger" @click="eliminar()">
                Eliminar
              </b-button>
            </template>
    
          </b-modal>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
    import FeedbackNuevo from '@/components/Cursos/Temas/Feedback/Nuevo';
    import FeedbackEditar from '@/components/Cursos/Temas/Feedback/Editar';
    import FeedbackDetalle from '@/components/Cursos/Temas/Feedback/Detalle';
    
    export default {
      name: 'FeedbackLista',
      components: {
        FeedbackNuevo,
        FeedbackEditar,
        FeedbackDetalle
      },
      props:{
        tema_id:String,
        editar:{
          type: Boolean,
          default: false
        }
      },
      data () {
        return {
            logro:null,
            show_nuevo: false,
            show_detalle: false,
            show_editar:false,
            show_eliminar:false
        }
      },
      mounted () {
        this.actualizar();
      },
      methods:{
        ...mapActions({
            fetchLista: 'temas_adicional/fetchLista',
        }),
        ...mapMutations({
          
        }),
        actualizar(){
          this.fetchLista({tema_id:this.tema_id,tipo:"feedback"})
        },
        nuevo() {
          this.show_nuevo = true;
        },
        view(item) {
          this.show_detalle = true;
          this.logro = item;
        },
        edit(item) {
          this.show_editar = true;
          this.logro = item;
        },
        remove(item) {
          this.show_eliminar = true;
          this.logro = item;
        },
        eliminar() {
          this.eliminarLogro(this.logro).then((result) => {
            console.log(result)
            this.actualizar()
          }).finally(() => {
            this.show_eliminar = false;
          });
        },
      },
      computed: {
        ...mapState({
            lista: state => state.temas_adicional.lista, 
            detalle: state => state.temas.detalle, 
        }),
        ...mapGetters({
            permiso: 'auth/permiso', 
          }),
        tema(){
            if(this.detalle && this.detalle[this.tema_id]){
                return this.detalle[this.tema_id]  
            }else{
                return {nombre:"Tema desconocido"}
            }
        },
      }
    }
  </script>
  
  <style scope>
  
  </style>
  